export type UserContextProps = {
  userDetails: UserWithoutRole
  getUserDetails: () => Promise<UserWithoutRole | ClientWithoutRole>
  changeProfilePicture: (base64ImageUrl: string) => Promise<string>
  changeUserDetails: (userDetails: UserWithoutRole | ClientWithoutRole) => Promise<void>
}
  
export type UserProviderProps = {
  userDetails: UserWithoutRole
  getUserDetails: () => Promise<UserWithoutRole | ClientWithoutRole>
  changeProfilePicture: (base64ImageUrl: string) => Promise<string>
  changeUserDetails: (userDetails: UserWithoutRole | ClientWithoutRole) => Promise<void>
  children: React.ReactNode
}
  
export type User = {
  id: number
  company?: Company
  firstName: string
  lastName: string
  email: string
  role: UserRole
  profilePicture?: string
  phone?: string
  position?: string
  country?: string
  state?: string
  street?: string
  zipCode?: string
  city?: string
}

export type Client = Omit<User, 'firstName' | 'lastName'>

export enum UserRole {
  ADMIN = 'admin',
  INSTRUCTOR = 'instructor',
  PARTICIPANT = 'participant',
  CLIENT = 'client'
}

export type Company = {
  id: number
  name: string
  street: string
  zipCode: string
  city: string
  country: string
}

export type UserWithoutRole = Omit<User, 'role'>
export type ClientWithoutRole = Omit<Client, 'role'>